"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constantly = void 0;
function constantly(v) {
    return function constantly(...args) {
        return v;
    };
}
exports.constantly = constantly;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRseS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9jb25zdGFudGx5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQWdCLFVBQVUsQ0FBQyxDQUFNO0lBQzdCLE9BQU8sU0FBUyxVQUFVLENBQUMsR0FBRyxJQUFXO1FBQ3JDLE9BQU8sQ0FBQyxDQUFDO0lBQ2IsQ0FBQyxDQUFBO0FBQ0wsQ0FBQztBQUpELGdDQUlDIn0=